module.exports = __webpack_public_path__ + "img/Dantam Hair 56.43d29312.jpg";